export default "__VITE_ASSET___hTbtgix__"